import {z} from 'zod'
import {zx} from 'shared/type'
import {HiLightBulb, HiStar} from 'react-icons/hi'
import {sb} from 'utils/db'

const questionTypes = ['general', 'rating'] as const

export namespace Feedback {
  export const zAdmin = z
    .object({
      questionOrder: z.array(z.string()).default([])
    })
    .describe('feedback-admin')

  export const zQuestionCommon = z
    .object({
      type: z.enum(questionTypes),
      title: z.string().default(''),
      description: z.string().default(''),
      enabled: z.boolean().default(true)
    })
    .passthrough()
    .describe('feedback-question')

  export const md = {
    general: {
      label: 'feedback question',
      admin: zQuestionCommon.extend({type: z.literal('general')}),
      response: z
        .object({
          title: z.string().default(''),
          description: z.string().default(''),
          vote_sum: zx.nullish.num.default(0),
          vote_count: zx.nullish.num.default(0)
        })
        .describe('feedback-response-general'),
      vote: z
        .object({
          vote: z.number().gte(-2).lte(2).default(0)
        })
        .describe('feedback-response-vote'),
      Icon: HiLightBulb,
      defaultCfg: {
        type: 'general',
        title: 'General Feedback',
        description:
          'Anonymously provide your thoughts, feedback, or suggestions on how we can improve your experience with the app, workshops or otherwise. Additionally, you can vote on ideas proposed by others.',
        enabled: true
      }
    },
    rating: {
      label: 'rating',
      admin: zQuestionCommon.extend({
        type: z.literal('rating'),
        rating_avg: zx.nullish.num.default(0),
        rating_count: zx.nullish.num.default(0)
      }),
      response: z.object({rating: z.number()}).describe('feedback-response-rating'),
      Icon: HiStar
    }
  } //satisfies Record<string, {label?:string, admin: ZodSchema<any>, response: ZodSchema<any>}>
  type QuestionType = keyof typeof md
  export const zQuestion = z.union([md.general.admin, md.rating.admin]).describe('feedback-question')
  export type Question = z.infer<typeof zQuestion>
  // type FeedbackQuestionGeneral = z.infer<typeof md.general.admin>
  export type QuestionRating = z.infer<typeof md.rating.admin>

  export const createDefaultQuestionIfRequired = async ({
    profile_id,
    workspace_id
  }: {
    profile_id: string
    workspace_id: string
  }) => {
    const {data, error} = await sb
      .from('ui_workspace')
      .select('cfg')
      .match({workspace_id, path: 'feedback', sub_path: 'default'})
      .maybeSingle()
    if (error) throw error
    if (data) return
    await sb.from('ui_workspace').insert({
      created_by: profile_id,
      workspace_id,
      path: 'feedback',
      sub_path: 'default',
      type: 'feedback-question',
      cfg: md.general.defaultCfg
    })
  }
}
